export default "__VITE_ASSET__RQtyokXj__"